import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Tooltip, makeStyles, useTheme } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import Typography from "../../../../components/Helpers/Typography";

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: "0.9rem",
    fontWeight: "normal",
  },
}));

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(124, 124, 124, 0.5);
  color: ${(props) => props.theme.palette.text.secondary};
  &:last-child {
    border-bottom: 0;
  }
`;

const VehicleDataRow = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Wrapper theme={theme} {...props} data-testid={props.dataKey}>
      <Typography style={{ fontSize: 16 }}>
        {props.dataKey}
        {props.tooltip && (
          <Tooltip title={props.tooltip} placement="bottom" classes={{ tooltip: classes.tooltip }}>
            <InfoIcon style={{ fontSize: "1rem", marginLeft: "0.5rem" }} />
          </Tooltip>
        )}
      </Typography>
      {props.children}
    </Wrapper>
  );
};

VehicleDataRow.propTypes = {
  dataKey: PropTypes.string,
  children: PropTypes.node,
  tooltip: PropTypes.string,
};

VehicleDataRow.defaultProps = {
  dataKey: "placeholder",
  children: null,
  tooltip: "",
};

export default VehicleDataRow;
